import React, { useState, useEffect, } from 'react';
import { Dialog, DialogContent, DialogTitle, Grid, Button, Typography, TextField, Slide, } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import colors from '../../colors';
import { texts } from '../texts';
import CountrySelect from './CountrySelect';
import CloseIcon from '@mui/icons-material/Close';
import { selectGlobalDataState } from '../../../features/global/globalDataSlice';
import { closeUanatacaDialog } from '../../../features/utilities/utilitySlice';
import { sendGeneralRequest } from '../../../features/generalRequest';
import { useDispatch, useSelector } from "react-redux";
import { selectUtilityState } from '../../../features/utilities/utilitySlice';
import CircularProgress from '@mui/material/CircularProgress';
import BytesToPdf from './BytesToPdf';
import FacephiFlow from '../../registration/facephi/FacephiFlow';
import { selectRegistrationState } from '../../../features/registration/registrationSlice';
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    })
}));

const UanatacaDialog = ({ isDialogOpened, handleCloseDialog }) => {
    const dispatch = useDispatch();
    const [serialNr, setSerialNr] = useState('');
    const [selphiComplete, setIsSelphiCompleted] = useState(false);
    const [selphIdComplete, setIsSelphIdCompleted] = useState(false);
    const [countryID, setCountryID] = useState('AL');
    const [secretField, setSecretField] = useState(false);
    const [secretNr, setSecretNr] = useState('');
    const globalDataSliceState = useSelector(selectGlobalDataState);
    const utilitySliceState = useSelector(selectUtilityState);
    const registrationSliceState = useSelector(selectRegistrationState);

    const handleCountryChange = (selectedCountry) => {
        setCountryID(selectedCountry.code)
    }

    const handleClose = () => {
        handleCloseDialog(false);
        dispatch(closeUanatacaDialog());
    };

    const handleSerialNumberChange = (event) => {
        setSerialNr(event.target.value);
    };

    const handleSubmit = () => {
        let updatedCountryID = countryID;
        let updatedSerialNr = serialNr;
        if (
            utilitySliceState.checkFacePhiResponse.documentNumber !== '' ||
            utilitySliceState.checkFacePhiResponse.nationality !== ''
        ) {
            updatedCountryID = utilitySliceState.checkFacePhiResponse.nationality;
            updatedSerialNr = utilitySliceState.checkFacePhiResponse.documentNumber;
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, ID_Doc_Country: updatedCountryID, serialNr: updatedSerialNr }, baseUrlKey: "services", endpoint: "CreateUanatacaRequest" }));
        }
        else {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, ID_Doc_Country: countryID, serialNr: serialNr }, baseUrlKey: "services", endpoint: "CreateUanatacaRequest" }));
        }
    };

    useEffect(() => {
        if (registrationSliceState.countryCode !== '' && utilitySliceState.isUanatacaDialogOpen) {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, ID_Doc_Country: registrationSliceState.countryCode, serialNr: registrationSliceState.docNumber }, baseUrlKey: "services", endpoint: "CreateUanatacaRequest" }));
        }
    }, [registrationSliceState.countryCode, registrationSliceState.docNumber])

    useEffect(() => {
        if (utilitySliceState.isUanatacaCreated) {
            dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token }, baseUrlKey: "services", endpoint: "GetContract" }));
        }
    }, [utilitySliceState.isUanatacaCreated]);


    const handleSecretNumberChange = (event) => {
        setSecretNr(event.target.value);
    };

    const setOnSelphiComplete = (event) => {
        setIsSelphiCompleted(event)
    };

    const setOnSelphIdComplete = (event) => {
        setIsSelphIdCompleted(event)
    };

    const confirmSignature = () => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, secret: secretNr }, baseUrlKey: "services", endpoint: "SignatureAcceptanceAndSMSConfirm" }));
    }

    useEffect(() => {
        if (utilitySliceState.isSignatureConfirmed) {
            handleClose()
        }
    }, [utilitySliceState.isSignatureConfirmed]);


    return (
        <Dialog
            open={isDialogOpened}
            onClose={handleClose}
            TransitionComponent={Transition}
            keepMounted
            fullWidth
            maxWidth="lg"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            PaperProps={{
                style: {
                    borderRadius: '20px',
                    height: '80vh',
                    padding: '30px',
                    zIndex: 888
                },
            }}
        >
            <DialogTitle marginBottom={5}>
                <Grid container justifyContent={'right'} ><Button onClick={handleClose} sx={{ color: colors.orange, mt: '2%', mr: '1%', borderRadius: '10px', height: '3vh' }} ><CloseIcon /></Button></Grid>
                <Grid container item md={12} xs={12} justifyContent={'center'}>
                    <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '1.5rem' }}>Ndiqni hapat e mëposhtme për firmosjen elektronike</Typography>
                </Grid>
            </DialogTitle>
            {(!utilitySliceState.bytes && isDialogOpened) && (
                <>
                    {utilitySliceState.checkFacePhiResponse && !utilitySliceState.checkFacePhiResponse.facephiManadatory  && (
                        <DialogContent>
                            <Grid container marginTop={1} justifyContent={'center'}>
                                {(utilitySliceState.checkFacePhiResponse.documentNumber !== '' && utilitySliceState.checkFacePhiResponse.documentNumber !== undefined && utilitySliceState.checkFacePhiResponse.documentNumber !== null) ?
                                    (
                                        <TextField id="serialNr" name="serialNr" size="large" color="warning" label="Numri Dokumentit" variant='standard' 
                                        sx={{ width: '288px', marginRight: window.innerWidth <= 600 ? '0px' : '20px', marginBottom: window.innerWidth <= 600 ? '20px' : 0 }} 
                                        value={ utilitySliceState.checkFacePhiResponse.documentNumber }
                                        disabled={true} 
                                        />
                                    )
                                        :
                                        (
                                            <TextField id="serialNr" name="serialNr" size="large" color="warning" label="Numri Dokumentit" variant='standard' 
                                            sx={{ width: '288px', marginRight: window.innerWidth <= 600 ? '0px' : '20px', marginBottom: window.innerWidth <= 600 ? '20px' : 0 }} 
                                            onChange={handleSerialNumberChange} 
                                            />
                                        )}
                                <CountrySelect onCountryChange={handleCountryChange} />
                                <Button
                                    onClick={() => handleSubmit()}
                                    disabled={utilitySliceState.checkFacePhiResponse.documentNumber === '' && utilitySliceState.checkFacePhiResponse.nationality === '' && serialNr === ''}
                                    style={{
                                        background: colors.orange,
                                        cursor: 'pointer',
                                        color: colors.white,
                                        padding: '15px',
                                        borderRadius: '5px',
                                        borderColor: 'transparent',
                                        fontFamily: 'GerberaBold',
                                        textTransform: 'none',
                                        fontSize: '1rem',
                                        marginLeft: window.innerWidth <= 600 ? '0px' : '20px',
                                        marginTop: window.innerWidth <= 600 ? '20px' : '0px',
                                        opacity: (utilitySliceState.checkFacePhiResponse.documentNumber === '' && utilitySliceState.checkFacePhiResponse.nationality === '' && serialNr === '' )? 0.6 : 1,
                                    }}
                                >
                                    {texts['button-confirm']}
                                </Button>
                            </Grid>
                            <Grid container style={{ marginTop: '150px' }} justifyContent={"center"}>
                                <Grid container item mt={10} md={2} xs={2}>
                                    {utilitySliceState.isLoading && (
                                        <CircularProgress color="warning" />
                                    )}
                                </Grid>
                            </Grid>
                        </DialogContent>
                    )}

                    {utilitySliceState.checkFacePhiResponse && (utilitySliceState.checkFacePhiResponse.facephiManadatory) && (
                        <>
                            {registrationSliceState.docNumber === '' && (<Grid
                                style={{

                                    marginLeft: window.innerWidth <= 600 ? 0 : (!selphiComplete ? '-40px' : '-320px'),
                                    marginTop: window.innerWidth <= 600 ? 40 : '90px'

                                }}
                            >
                                <FacephiFlow onSelphiComplete={setOnSelphiComplete} onSelphIdComplete={setOnSelphIdComplete} isUanataca={true} />
                            </Grid>)}
                            <Grid container style={{ marginTop: '150px' }} justifyContent={"center"}>
                                <Grid container item mt={10} ml={2} md={2} xs={2}>
                                    {utilitySliceState.isLoading && (
                                        <CircularProgress color="warning" />
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )}
                </>
            )}
            {(utilitySliceState.bytes && !secretField) && (
                <DialogContent>
                    <Grid container item mt={10} ml={2} md={2} xs={2}>
                                    {utilitySliceState.isLoading && (
                                        <CircularProgress color="warning" />
                                    )}
                                </Grid>
                    <BytesToPdf pdfByteArray={utilitySliceState.bytes} />
                    <Grid container item md={12} xs={12} marginTop={1} justifyContent={'center'}>
                        <Button
                            onClick={() => (setSecretField(true))}
                            style={{
                                background: colors.orange,
                                cursor: 'pointer',
                                color: colors.white,
                                padding: '15px',
                                borderRadius: '5px',
                                borderColor: 'transparent',
                                fontFamily: 'GerberaBold',
                                textTransform: 'none',
                                fontSize: '1rem',
                                marginLeft: '20px',
                            }}
                        >
                            {texts['button-sign']}
                        </Button>
                    </Grid>
                </DialogContent>
            )}
            {secretField && (
                <DialogContent>
                    <Grid container item md={12} xs={12} marginTop={1} justifyContent={'center'}>
                        <TextField id="secret" name="secret" size="medium" color="warning" label="Kodi sekret" sx={{ marginRight: '20px' }} onChange={handleSecretNumberChange} />
                        <Button
                            onClick={() => confirmSignature()}
                            disabled={secretNr === ''}
                            style={{
                                background: colors.orange,
                                cursor: 'pointer',
                                color: colors.white,
                                padding: '15px',
                                borderRadius: '5px',
                                borderColor: 'transparent',
                                fontFamily: 'GerberaBold',
                                textTransform: 'none',
                                fontSize: '1rem',
                                marginLeft: '20px',
                                marginTop: window.innerWidth <= 600 ? '10px' : '0px',
                                opacity: secretNr === '' ? 0.6 : 1,
                            }}
                        >
                            {texts['button-confirm']}
                        </Button>
                    </Grid>
                    <Grid container style={{ marginTop: '150px' }} justifyContent={"center"}>
                        <Grid container item mt={8} md={1} xs={2}>
                            {utilitySliceState.isLoading && (
                                <CircularProgress color="warning" />
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
            )}
        </Dialog>
    )
}

export default UanatacaDialog;